import React, { useContext } from "react";
import { Link, ResourceItem, InlineStack, Text, BlockStack } from "@shopify/polaris";

// import helpers
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";

// import props
import { rowProp } from "app/payments/modules/operator/features/list/propTypes";

function CommissionRevenueRow(props) {
  const { currentUser } = useContext(PrivateContext);
  const { item } = props;
  const { _id: id } = item;
  const { moneyFormat } = currentUser;

  const isVendor = baseHelper.isVendor(currentUser);

  const renderOrderRow = (items) => {
    const {
      commissionSeller,
      name: vendor,
      _id: userId,
      totalPrice,
      // eslint-disable-next-line no-shadow
    } = items;
    let commissionPercentage = (commissionSeller / totalPrice) * 100;
    if (commissionPercentage && commissionPercentage % 1 !== 0) {
      commissionPercentage = baseHelper.getPrice(commissionPercentage);
    }

    return (
      <>
        <BlockStack align="start">
          <div className="hidden" title={vendor}>
            {"Vendor Name: "}
            {(isVendor && vendor) || <Link url={`/providers/view/${userId}`}>{vendor}</Link>}
          </div>
          <Text as="span">
            {`Operator Commission: ${moneyFormat} ${baseHelper.getPrice(commissionSeller)} (${
              commissionPercentage || 0
            }%)`}
          </Text>
          <Text as="span">{`Revenue: ${moneyFormat} ${baseHelper.getPrice(totalPrice)}`}</Text>
        </BlockStack>
      </>
    );
  };

  return (
    <>
      <ResourceItem id={id}>{renderOrderRow(item)}</ResourceItem>
    </>
  );
}

CommissionRevenueRow.propTypes = rowProp.type;
export default CommissionRevenueRow;
